module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS44NDYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMS44NDYgMTQiPgogICAgPGcgZmlsbD0ibm9uZSI+CiAgICAgICAgPHBhdGggZD0iTTcgMGw3IDExLjg0NkgweiIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNS45MjMgNS45MjMpIi8+CiAgICAgICAgPHBhdGggZmlsbD0iIzY3NDk4MiIgZD0iTTcgMS45NjZsLTUuMjQ4IDguODhoMTAuNDk2TDcgMS45NjZNNyAwbDcgMTEuODQ2SDBMNyAweiIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNS45MjMgNS45MjMpIi8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/triangle-right-purple.svg
// module id = 2fE6
// module chunks = 1